import React from 'react'
import InfoIcon from "website/home/info-icon.svg"
import Tooltip from 'react-bootstrap/Tooltip';
import {OverlayTrigger} from 'react-bootstrap';
import {
  allowNumericOnly,
  numberWithCommas,
  numberAddCommas,
  numberClearCommas,
  presenceErrorClass,
} from 'servos/formValidations'

const EstimateInput = ({
  isInterestRate,
  value,
  onChange,
  id,
  label,
  tooltipText,
  placeholder,
  icon
 }) => {
  const handleKeyPress = isInterestRate ? null : allowNumericOnly
  const currentValue = isInterestRate ? value : numberAddCommas(value)

  const handleFocus = () => {
    const dom = document.querySelector(`#${id}`);
    dom.style.borderColor = '#10C98E';
  }

  const handleBlur = () => {
    const dom = document.querySelector(`#${id}`);
    dom.style.borderColor = '#90AEAA';
  }

  const tooltip = (
    <Tooltip id="homepage-refinance-calculator-tooltip">
      {tooltipText}
    </Tooltip>
  );

  return (
    <div>
      <div className='estimate-input-label'>
        {label}
        <OverlayTrigger
          placement="right"
          overlay={tooltip}
        >
          <InfoIcon className='ml-2' />
        </OverlayTrigger>
      </div>
      <div className="input-group">
        {icon === '$' &&
          <div className="input-group-prepend">
            <div id={id} className="input-group-text">{icon}</div>
          </div>
        }
        <input
          onKeyPress={ handleKeyPress }
          className="form-control form-control-lg"
          value={currentValue}
          onChange={onChange}
          placeholder={placeholder}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {icon !== '$' &&
          <div className="input-group-append">
            <div id={id} className="input-group-text">{icon}</div>
          </div>
        }
      </div>
    </div>
  );
}

export default EstimateInput;
